import type { ObjectHouseRules } from '@/domain';

type HouseRulesProps = {
    houseRules: ObjectHouseRules;
};

export const HouseRules = ({ houseRules }: HouseRulesProps) => (
    <ul className="list grid grid-cols-2 md:grid-cols-3 gap-8 mt-16" data-testid="houseRulesList">
        {houseRules.wheelchairAccessible ? (
            <li key="houseRuleWheelchair" className="flex items-center">
                <w-icon name="Check" size="small" />
                <span className="ml-8">Rullestolvennlig</span>
            </li>
        ) : (
            <li key="houseRuleNoWheelchair" className="flex items-center">
                <w-icon name="Close" size="small" />
                <span className="ml-8">Ikke rullestolvennlig</span>
            </li>
        )}
        {houseRules.smokingAllowed ? (
            <li key="houseRulesSmoking" className="flex items-center">
                <w-icon name="Check" size="small" />
                <span className="ml-8">Røyking tillatt</span>
            </li>
        ) : (
            <li key="houseRulesNoSmoking" className="flex items-center">
                <w-icon name="Close" size="small" />
                <span className="ml-8">Røyking ikke tillatt</span>
            </li>
        )}
        {houseRules.petsAllowed ? (
            <li key="houseRulesPets" className="flex items-center">
                <w-icon name="Check" size="small" />
                <span className="ml-8">Kjæledyr tillatt</span>
            </li>
        ) : (
            <li key="houseRulesNoPets" className="flex items-center">
                <w-icon name="Close" size="small" />
                <span className="ml-8">Kjæledyr ikke tillatt</span>
            </li>
        )}
    </ul>
);
